import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Calibri', 'Segoe UI', 'Arial', sans-serif`,
    body: `'Calibri', 'Segoe UI', 'Arial', sans-serif`,
  },
  styles: {
    global: {
      'html, body': {
        fontSize: '16px',
        color: 'gray.700',
        lineHeight: 'tall',
        backgroundColor: '#EEEEEE',  // Add background color here
        // backgroundColor: '#DCDCDC',  // Add background color here
        overflowX: 'hidden',  // Prevent horizontal scrolling
        maxWidth: '100vw',    // Ensure content doesn't exceed viewport width
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        textRendering: 'optimizeLegibility',
      },
      // Ensure SimpleGrid components don't overflow
      '.chakra-simple-grid': {
        maxWidth: '100%',
        overflowX: 'hidden',
      },
      // Ensure all grid containers are responsive
      '[class*="chakra-simple-grid"]': {
        maxWidth: '100%',
        overflowX: 'hidden',
      },
      // Ensure sidebar components don't overflow
      '[role="complementary"], aside': {
        maxWidth: '100%',
        overflowX: 'hidden',
      },
      // Ensure flex containers in sidebar don't overflow
      'aside .chakra-flex': {
        maxWidth: '100%',
        overflowX: 'hidden',
      },
      // Ensure text doesn't cause overflow in sidebar
      'aside .chakra-text': {
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
      },
    //   a: {
    //     color: 'teal.500',
    //   },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontWeight: 'bold',
      },
      sizes: {
        xl: {
          fontSize: '48px',
        },
        lg: {
          fontSize: '36px',
        },
        md: {
          fontSize: '24px',
        },
        sm: {
          fontSize: '20px',
        },
      },
      variants: {
        primary: {
          color: 'teal.700',
        },
        secondary: {
          color: 'gray.700',
        },
      },
    },
    Text: {
      baseStyle: {
        fontFamily: 'body',
        fontWeight: 'normal',
      },
      sizes: {
        xl: {
          fontSize: '24px',
        },
        lg: {
          fontSize: '20px',
        },
        md: {
          fontSize: '16px',
        },
        sm: {
          fontSize: '14px',
        },
      },
      variants: {
        primary: {
          color: 'teal.700',
        },
        secondary: {
          color: 'gray.700',
        },
      },
    },
  },
});

export default theme;
